<template>
  <CSidebar
    position="fixed"
    :unfoldable="sidebarUnfoldable"
    :visible="sidebarVisible"
    @visible-change="(event) => $store.commit({ type: 'updateSidebarVisible', value: event })"
  >
    <CSidebarBrand style="background: white; display: flex; justify-content: center; align-items: center;">
      <img 
        src="../assets/images/itermigologo.png" 
        alt="Logo" 
        style="width: 80%; height: 60px; margin-left: 0; margin-right: 30px;" 
      />
    </CSidebarBrand>
    <AppSidebarNav />
  </CSidebar>
</template>

<script>
import { computed } from 'vue'
import { useStore } from 'vuex'
import { AppSidebarNav } from './AppSidebarNav'
import { sygnet } from '@/assets/brand/sygnet'

export default {
  name: 'AppSidebar',
  components: {
    AppSidebarNav,
  },
  props: {
    id: String,
    type: String
  },
  setup() {
    const store = useStore()
    return {
      sygnet,
      sidebarUnfoldable: computed(() => store.state.sidebarUnfoldable),
      sidebarVisible: computed(() => store.state.sidebarVisible),
    }
  },
}
</script>
